import { createEnumOptions } from '@kinet-open-network/shared/data-access/model';

export const FILLING_PLANT_ID = 'filling-plant';

export const FILLING_PLANT_LABEL = 'Plniareň';

export enum PbgasStockType {
  fillingPlant = 'fillingPlant',
}

export const pbgasStockTypes = Object.values(PbgasStockType);

export const pbgasStockTypeOptions = createEnumOptions<PbgasStockType>({
  [PbgasStockType.fillingPlant]: { label: FILLING_PLANT_LABEL },
  _default: { label: '-' },
});

// Module augmentation — makes 'fillingPlant' a valid StockType at compile time
declare module '@kinet-open-network/shared/data-access/model' {
  interface StockTypeExtensions {
    pbgas: PbgasStockType;
  }
}
